normalizeStringifyOptions